import { skipToken, useQuery } from "@tanstack/react-query";
import { getPayPointsPublicIDTerminalActivation } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TERMINAL_ACTIVATION_CODE_QUERY_KEY = "TERMINAL_ACTIVATION_CODE";

export const terminalActivationCodeKeys = {
  all: [TERMINAL_ACTIVATION_CODE_QUERY_KEY],
  byPayPointPublicId: (payPointPublicID?: string | null) => [
    TERMINAL_ACTIVATION_CODE_QUERY_KEY,
    payPointPublicID,
  ],
};

/**
 * Activation code of a terminal PayPoint. Only terminals that pair by code (SoftPOS app, P300) have one;
 * for NEXGO terminals and unregistered PayPoints the code is null. Owner merchant and staff only.
 */
export const useTerminalActivationCodeQuery = (
  payPointPublicID?: string | null,
  enabled = true,
) =>
  useQuery({
    queryKey: terminalActivationCodeKeys.byPayPointPublicId(payPointPublicID),
    queryFn:
      enabled && payPointPublicID
        ? processResponseWithApiProblemDetails(() =>
            getPayPointsPublicIDTerminalActivation(payPointPublicID),
          )
        : skipToken,
  });
